import React from 'react';
import { Page } from '../Page';
import { Beef, Leaf, Milk } from 'lucide-react';
const seaProteins = [{
  name: 'Salmon',
  img: 'https://cdn.magicpatterns.com/uploads/7tSyAhvGY3jp4Lk1sASC4Y/1.png'
}, {
  name: 'Tuna',
  img: 'https://cdn.magicpatterns.com/uploads/dKgxchhHgEkx8MDhf5axwV/2.png'
}, {
  name: 'Halibut',
  img: 'https://cdn.magicpatterns.com/uploads/iaYW6pyVPoiZZCq8WuvQut/3.png'
}, {
  name: 'Shrimp',
  img: 'https://cdn.magicpatterns.com/uploads/nNNyBVtiNNkbeBwJdWbHZo/4.png'
}, {
  name: 'Crab',
  img: 'https://cdn.magicpatterns.com/uploads/snr7C9q4emdrWn6mXqpxkr/5.png'
}];
const landProteins = [{
  name: 'Chicken Breast',
  img: 'https://cdn.magicpatterns.com/uploads/uyUcpm2TEUtfj76LGBJDps/7.png'
}, {
  name: 'Turkey/Ground',
  img: 'https://cdn.magicpatterns.com/uploads/8Jy2j9wVbMUPrvevKq73aA/6.png'
}, {
  name: 'Eggs',
  img: 'https://cdn.magicpatterns.com/uploads/68Ld573hKnRG1fNq4E5akd/8.png'
}, {
  name: 'Bison',
  img: 'https://cdn.magicpatterns.com/uploads/1J4Kzg9SfYHVmir2rUKn9f/9.png'
}, {
  name: '90/10 Ground Beef',
  img: 'https://cdn.magicpatterns.com/uploads/9dMavTJCCdMyZ9vauci1ar/10.png'
}];
const earthProteins = [{
  name: 'Tofu',
  img: 'https://cdn.magicpatterns.com/uploads/kX8bvqkN39AU7hKi8NdDQV/1.png'
}, {
  name: 'Lentils',
  img: 'https://cdn.magicpatterns.com/uploads/4SLPv34Pg2mTjqVnd5iHcJ/2.png'
}, {
  name: 'Chickpeas',
  img: 'https://cdn.magicpatterns.com/uploads/dRVkhurRZZ3WuDiMnw2Zdx/3.png'
}, {
  name: 'Pea Protein',
  img: 'https://cdn.magicpatterns.com/uploads/mHumJF8GF7w4ENVn6Pu281/4.png'
}, {
  name: 'Edamame',
  img: 'https://cdn.magicpatterns.com/uploads/uPzhMp6Tt5VtABszK134eN/5.png'
}];
function ProteinRow({
  title,
  icon,
  items
}: {
  title: string;
  icon?: React.ReactNode;
  items: {
    name: string;
    img: string;
  }[];
}) {
  return <div className="border border-[#D8D8D0] bg-[#EAEAE4] overflow-hidden" data-id="element-890" data-mp="3g5tze0esnij7">
      <div className="bg-navyslate px-3 py-2 flex items-center gap-2" data-id="element-891" data-mp="385o09gff9v5k">
        {icon}
        <h2 className="text-xs font-serif text-white" data-id="element-892" data-mp="34540s67dmfg9">{title}</h2>
      </div>
      <div className="p-3" data-id="element-893" data-mp="3hxjzwvx5ptbw">
        <div className="flex justify-between items-center" data-id="element-894" data-mp="3hwsh6lonrq31">
          {items.map((item, i) => <div key={i} className="flex flex-col items-center gap-1" data-id="element-895" data-mp="3cyqvru3rfeoe" data-mpi={i}>
              <div className="w-20 h-14 flex items-center justify-center" data-id="element-896" data-mp="2p7v02lw6nzbv">
                <img src={item.img} alt={item.name} className="max-w-full max-h-full object-contain" data-id="element-897" data-mp="2l7b0zcs1uln3" />
              </div>
              <span className="text-[10px] font-medium text-[#3B3B3B] text-center" data-id="element-898" data-mp="2u7pqypfykowx">
                {item.name}
              </span>
            </div>)}
        </div>
      </div>
    </div>;
}
export function Page4() {
  return <Page pageNumber={11} variant="light" data-id="element-899" data-mp="9gfhynwurm6w">
      <div className="flex flex-col h-full" data-id="element-900" data-mp="9juv3l6yul5o">
        <div className="mb-6 pt-4" data-id="element-901" data-mp="1re2betragc6a">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-902" data-mp="1rdsmzalw6d2p">
            The Essentials
          </p>
          <h1 className="text-4xl font-serif text-[#1F1F1F] leading-tight mb-3" data-id="element-903" data-mp="1iep15yvcbjki">
            Choosing <span className="text-tealslate" data-id="element-904" data-mp="1ndigzxy3nmnu">Lean Proteins</span>
          </h1>
          <p className="text-sm text-[#3B3B3B] leading-[1.8] max-w-lg" data-id="element-905" data-mp="1nfmik98j09ky">
            Choosing lean proteins helps reduce calories, promote heart health,
            and reduce the risk of GLP-1 side effects like nausea and vomiting.
          </p>
        </div>

        <div className="space-y-3 flex-1" data-id="element-906" data-mp="21c890z62aw5c">
          <ProteinRow title="From The Sea" items={seaProteins} data-id="element-907" data-mp="21bgqoq1h6ux0" />
          <ProteinRow title="From The Land" icon={<Beef className="w-4 h-4 text-lightteal" data-id="element-909" data-mp="2u1fao70tc1ut" />} items={landProteins} data-id="element-908" data-mp="26b32cv1no33p" />
          <ProteinRow title="From The Earth" icon={<Leaf className="w-4 h-4 text-lightteal" data-id="element-911" data-mp="2yurtu1mq3gg6" />} items={earthProteins} data-id="element-910" data-mp="2yt73ypbcslon" />

          <div className="border border-[#D8D8D0] bg-[#EAEAE4] overflow-hidden" data-id="element-912" data-mp="1a4hvof8cb8di">
            <div className="bg-navyslate px-3 py-2 flex items-center gap-2" data-id="element-913" data-mp="156gdrxmnhf3m">
              <Milk className="w-4 h-4 text-lightteal" data-id="element-914" data-mp="116z7j1zegdxe" />
              <h2 className="text-xs font-serif text-white" data-id="element-915" data-mp="w7crylw3mllf">From The Cow</h2>
            </div>
            <div className="p-3" data-id="element-916" data-mp="1sxc9v6y52wgo">
              <div className="flex flex-wrap gap-2" data-id="element-917" data-mp="1swan457rglj4">
                {['Low Fat Milk', 'Low Fat Cottage Cheese', 'Low Fat Yogurt', 'Whey Protein'].map((item, i) => <div key={i} className="bg-bluegray/40 px-3 py-1.5 text-[11px] text-white font-medium border border-[#D8D8D0]" data-id="element-918" data-mp="1f5yt20rm8cpc" data-mpi={i}>
                    {item}
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Page>;
}